import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for guest-only auth URLs.
 *
 * Kept separate from `auth.ts` (the `RouteObject` tree) so callers can import paths
 * without creating a cycle through page `Component` imports.
 */
export const signInRoute = defineRoute("/signIn");
export const googleCallbackRoute = defineRoute("/auth/gcallback");
